module.exports = __webpack_public_path__ + "static/index/img/baikal-1002.01df7a61.jpg";